<template>
    <div class="">
        <dropdown :auto-width="false" px-width="300" open-from="right">
            <template #button>
                <div :class="buttonCss">Add to Calendar</div>
            </template>
            <template #content>
                <ul class="flex flex-col whitespace-nowrap">
                    <li>
                        <a
                            target="_blank"
                            class="block p-3 text-gray-700 hover:cursor-pointer hover:bg-gray-200"
                            :href="googleCalendarLink"
                            >Add to Google calendar</a
                        >
                    </li>
                    <li>
                        <a
                            target="_blank"
                            class="block p-3 text-gray-700 hover:cursor-pointer hover:bg-gray-200"
                            :href="
                                route('student.live-events.download-ical', {
                                    live_event: event.id,
                                })
                            "
                            >Add to Apple calendar
                        </a>
                    </li>
                </ul>
            </template>
        </dropdown>
    </div>
</template>
<script>
import dayjs from "dayjs";
import Dropdown from "@/Components/Dropdown.vue";

export default {
    name: "AddToCalendarWidget",
    components: { Dropdown },
    props: {
        buttonCss: {
            type: String,
            default:
                "inline-block bg-primary-525 px-3 py-2 text-[16px] text-white hover:cursor-pointer hover:bg-primary-600",
        },
        event: {
            type: Object,
            default: {},
        },
    },
    computed: {
        googleCalendarLink() {
            let eventTitle = "EMTprep.com - Live Webinar:" + this.event.title;
            let startDateTime = dayjs(this.event.starts_at).format(
                "YYYYMMDDTHHmmss"
            );
            let endDateTime = dayjs(this.event.starts_at)
                .add(2, "hours")
                .format("YYYYMMDDTHHmmss");

            return (
                "https://calendar.google.com/calendar/r/eventedit?text=" +
                eventTitle +
                "&dates=" +
                startDateTime +
                "/" +
                endDateTime
            );
        },
    },
};
</script>
